import { Empty } from "antd";
import { capitalizeName, convertSlote, formatDateFunction } from "../../../../utils/helper/utils";
import toast from "react-hot-toast";

const copyText = async (textToCopy, e) => {
  e.stopPropagation();
  try {
    await navigator.clipboard.writeText(textToCopy);
    toast.success("Copied to clipboard!");
  } catch (err) {
    toast.error("Failed to copy text");
  }
};

const OrderListing = ({ handleOrderDetail, list }) => {
  return (
    <>
      {list && list.length > 0 ? (
        list.map((item, index) => {
          const typeMapping = {
            qc: "QC",
            "qc-payment": "QC & Payment",
            "delivery-payment": "Delivery & Payment",
            "qc-delivery-payment": "QC, Delivery & Payment",
            delivery: "Delivery",
          };

          let productName = "";
          if (item?.orderDetails[0]?.type === "product") {
            for (let itm of item?.orderDetails[0].orderItemJson.productLocales) {
              if (itm.languageCode === "en") productName = itm.name;
            }
          } else {
            productName = "Custom Cake";
          }
          return (
            <div
              key={index}
              className={`border-gray-250 border-b p-3 cursor-pointer ${
                (!item.qcId || item.qcId === 0) && item.qcStatus === "" && item.status === "under_qa" ? "bg-red" : ""
              }`}
              onClick={() => {
                handleOrderDetail(item.id);
              }}
            >
              <div className="flex justify-between items-center gap-1 mb-2">
                <div className="font-bold text-[12px] whitespace-nowrap">
                  <span
                    onClick={(e) => copyText(item?.orderNumber, e)}
                    className="cursor-pointer hover:underline"
                    title="Click to copy order number"
                  >
                    #{item?.orderNumber}
                  </span>

                  {item?.platformOfOrder === "RH" ? (
                    <span
                      onClick={(e) => copyText(item?.rhOrderJson?.orderNumber, e)}
                      className="cursor-pointer hover:underline ml-1"
                      title="Click to copy RH order number"
                    >
                      ({item?.rhOrderJson?.orderNumber})
                    </span>
                  ) : null}
                </div>
                <div className="flex space-x-2">
                  <button className="px-2 py-1 rounded-md bg-gray-300 text-black text-[12px] whitespace-nowrap">
                    {typeMapping[item?.orderDeliveryType] || "Unknown Type"}
                  </button>
                </div>
              </div>
              <div className="flex">
                <div className="text-sm font-semibold">
                  {item?.orderDetails[0]?.quantity} x{" "}
                  {
                    productName
                    // item?.orderDetails[0]?.orderItemJson[0]?.productLocales[0]
                    //   ?.name
                  }
                  ...
                </div>
                {item?.orderDetails.length > 1 ? <div className="text-gray-200">+{item?.orderDetails.length - 1} more</div> : null}
              </div>
              <div className="flex justify-between">
                <div className="relative">
                  <div className="text-sm font-normal mt-[8px]">SAR {item?.totalAmount}</div>
                  <div className="text-sm font-normal mt-[8px]">PrepTime: {item?.totalPrepTime} min</div>
                  <div className="text-sm font-normal mt-[6px]">{item?.deliveryDate ? formatDateFunction(item?.deliveryDate, "dd/mm/yyyy") : null}</div>
                </div>
                <div className="flex flex-col justify-end items-end">
                  {item?.deliveryMode && item?.deliveryMode !== "" && item?.deliveryMode !== "pending" && item.status !== "placed" ? (
                    <div className="text-sm font-normal mt-[8px]">
                      Delivery Mode:
                      {item?.orderType === "regular"
                        ? item?.deliveryMode === "delivery"
                          ? "Home"
                          : capitalizeName(item?.deliveryMode)
                        : null}
                      {item?.orderType === "gift" ? "Gift" : null}
                      {/* Order Type: { item?.deliveryMode==='delivery' ? 'Home' : capitalizeName(item?.deliveryMode) }  */}
                      {/* <small>({capitalizeName(item?.orderType)})</small> */}
                    </div>
                  ) : null}
                  <div className="flex flex-col justify-end items-end">
                    <div className="text-sm font-normal mt-[8px]">{item?.user?.vendorDetail?.storeName}</div>
                  </div>
                  <div className="flex flex-col justify-end items-end">
                    <div className="text-sm font-normal mt-[8px]">
                      {item?.timeSlotDetails && Object.keys(item.timeSlotDetails).length > 0
                      ? (convertSlote(item?.timeSlotDetails.openTime) + " - " + convertSlote(item?.timeSlotDetails.closeTime))
                      : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="flex-auto pt-5 min-h-[300px] flex items-center justify-center">
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Orders are not Available" />
        </div>
      )}
    </>
  );
};

export default OrderListing;
